/*
 * Curated core-js polyfill list for the modern (ES modules) bundle.
 *
 * This replaces a blanket `import 'core-js/stable'`, which pulled the entire
 * core-js library into every application entry. Because the production build
 * uses esbuild (not Babel), Babel's `useBuiltIns: "entry"` trimming no longer
 * runs, so the full library was shipped untrimmed.
 *
 * This list contains only the polyfills required by the browser matrix that
 * the modern bundle is actually transpiled for (config/esbuild/config.js:
 * Chrome 80, Firefox 78, Safari 15, Edge 80). The bundle uses es2020 syntax
 * that older browsers cannot parse, so polyfilling below this floor is dead
 * weight. Older browsers load the separate legacy nomodule bundle, which has
 * its own polyfills in preESModulesPolyfills.js.
 *
 * DO NOT EDIT BY HAND. Regenerate with:
 *   node script/generate-corejs-polyfills.js
 */

import 'core-js/modules/es.symbol.async-dispose';
import 'core-js/modules/es.symbol.dispose';
import 'core-js/modules/es.error.cause';
import 'core-js/modules/es.error.is-error';
import 'core-js/modules/es.aggregate-error';
import 'core-js/modules/es.aggregate-error.cause';
import 'core-js/modules/es.suppressed-error.constructor';
import 'core-js/modules/es.array.at';
import 'core-js/modules/es.array.find-last';
import 'core-js/modules/es.array.find-last-index';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.push';
import 'core-js/modules/es.array.reduce';
import 'core-js/modules/es.array.reduce-right';
import 'core-js/modules/es.array.to-reversed';
import 'core-js/modules/es.array.to-sorted';
import 'core-js/modules/es.array.to-spliced';
import 'core-js/modules/es.array.unshift';
import 'core-js/modules/es.array.with';
import 'core-js/modules/es.data-view.get-float16';
import 'core-js/modules/es.data-view.set-float16';
import 'core-js/modules/es.array-buffer.detached';
import 'core-js/modules/es.array-buffer.transfer';
import 'core-js/modules/es.array-buffer.transfer-to-fixed-length';
import 'core-js/modules/es.disposable-stack.constructor';
import 'core-js/modules/es.iterator.constructor';
import 'core-js/modules/es.iterator.dispose';
import 'core-js/modules/es.iterator.drop';
import 'core-js/modules/es.iterator.every';
import 'core-js/modules/es.iterator.filter';
import 'core-js/modules/es.iterator.find';
import 'core-js/modules/es.iterator.flat-map';
import 'core-js/modules/es.iterator.for-each';
import 'core-js/modules/es.iterator.from';
import 'core-js/modules/es.iterator.map';
import 'core-js/modules/es.iterator.reduce';
import 'core-js/modules/es.iterator.some';
import 'core-js/modules/es.iterator.take';
import 'core-js/modules/es.iterator.to-array';
import 'core-js/modules/es.map.group-by';
import 'core-js/modules/es.math.f16round';
import 'core-js/modules/es.math.sum-precise';
import 'core-js/modules/es.number.to-exponential';
import 'core-js/modules/es.object.group-by';
import 'core-js/modules/es.object.has-own';
import 'core-js/modules/es.promise.any';
import 'core-js/modules/es.promise.try';
import 'core-js/modules/es.promise.with-resolvers';
import 'core-js/modules/es.array.from-async';
import 'core-js/modules/es.async-disposable-stack.constructor';
import 'core-js/modules/es.async-iterator.async-dispose';
import 'core-js/modules/es.reflect.to-string-tag';
import 'core-js/modules/es.regexp.escape';
import 'core-js/modules/es.regexp.flags';
import 'core-js/modules/es.set.difference.v2';
import 'core-js/modules/es.set.intersection.v2';
import 'core-js/modules/es.set.is-disjoint-from.v2';
import 'core-js/modules/es.set.is-subset-of.v2';
import 'core-js/modules/es.set.is-superset-of.v2';
import 'core-js/modules/es.set.symmetric-difference.v2';
import 'core-js/modules/es.set.union.v2';
import 'core-js/modules/es.string.at-alternative';
import 'core-js/modules/es.string.is-well-formed';
import 'core-js/modules/es.string.replace-all';
import 'core-js/modules/es.string.to-well-formed';
import 'core-js/modules/es.typed-array.at';
import 'core-js/modules/es.typed-array.find-last';
import 'core-js/modules/es.typed-array.find-last-index';
import 'core-js/modules/es.typed-array.set';
import 'core-js/modules/es.typed-array.to-reversed';
import 'core-js/modules/es.typed-array.to-sorted';
import 'core-js/modules/es.typed-array.with';
import 'core-js/modules/es.uint8-array.from-base64';
import 'core-js/modules/es.uint8-array.from-hex';
import 'core-js/modules/es.uint8-array.set-from-base64';
import 'core-js/modules/es.uint8-array.set-from-hex';
import 'core-js/modules/es.uint8-array.to-base64';
import 'core-js/modules/es.uint8-array.to-hex';
import 'core-js/modules/web.dom-exception.stack';
import 'core-js/modules/web.immediate';
import 'core-js/modules/web.self';
import 'core-js/modules/web.structured-clone';
import 'core-js/modules/web.url.can-parse';
import 'core-js/modules/web.url.parse';
import 'core-js/modules/web.url-search-params.delete';
import 'core-js/modules/web.url-search-params.has';
import 'core-js/modules/web.url-search-params.size';
